(function () {
  // REVIEWS / INSTAGRAM のページ送り（PC/SPで1ページの件数が異なる）
  var mq = window.matchMedia('(min-width: 750px)');
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-items] > *'));
    var label = root.querySelector('[data-label]');
    var page = 0;
    function per() { return parseInt(mq.matches ? root.dataset.perPc : root.dataset.perSp, 10) || 1; }
    function render() {
      var n = Math.max(1, Math.ceil(items.length / per()));
      page = ((page % n) + n) % n;
      items.forEach(function (el, i) { el.hidden = Math.floor(i / per()) !== page; });
      if (label) label.textContent = (page + 1) + ' / ' + n;
      root.querySelectorAll('[data-prev],[data-next]').forEach(function (b) { b.disabled = n <= 1; });
    }
    root.querySelectorAll('[data-prev]').forEach(function (b) { b.addEventListener('click', function () { page--; render(); }); });
    root.querySelectorAll('[data-next]').forEach(function (b) { b.addEventListener('click', function () { page++; render(); }); });
    mq.addEventListener('change', function () { page = 0; render(); });
    render();
  });
})();
